const endpoints = {
  navbar: 'profile/navbar.json',
  routes: 'profile/routes.json',
  home: 'profile/home.json',
  social: 'profile/social.json',
  about: 'profile/about.json',
  skills: 'profile/skills.json',
  education: 'profile/education.json',
  experience: 'profile/experience.json',
	projects: 'profile/projects.json',
	footer: 'profile/footer.json'
};

export default endpoints;
